/* global THREE */
import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";
import { stringifyRotation } from "@micosmo/aframe/lib/utils";

const rand = () => (Math.random() - 0.5) * 2;

let timeWarpFactor = 1;

aframe.registerComponent("bomber-spawn-zone", {
  init: function() {
    this._debugPlaneLeft = new THREE.Mesh(
      new THREE.PlaneGeometry(2, 2, 4),
      new THREE.MeshBasicMaterial({ color: "blue", side: THREE.DoubleSide })
    );
    this._debugPlaneLeft.position.x = -1;
    this._debugPlaneLeft.rotation.y = Math.PI / 2;
    this._debugPlaneLeft.visible = false;
    this.el.object3D.add(this._debugPlaneLeft);

    this._debugPlaneRight = new THREE.Mesh(
      new THREE.PlaneGeometry(2, 2, 4),
      new THREE.MeshBasicMaterial({ color: "blue", side: THREE.DoubleSide })
    );
    this._debugPlaneRight.position.x = 1;
    this._debugPlaneRight.rotation.y = Math.PI / 2;
    this._debugPlaneRight.visible = false;
    this.el.object3D.add(this._debugPlaneRight);

    this.poolEl = document.querySelector("[mipool__bomber]");

    window.spawnBomber = () => {
      this.spawnBomber();
    };
  },
  play: function() {
    if (!this.started) {
      this._gameState = document.querySelector("[game-state]").components[
        "game-state"
      ];
    }
    this.started = true;
  },
  spawnBomber: (() => {
    const v1 = new THREE.Vector3();
    const v2 = new THREE.Vector3();
    const up = new THREE.Vector3(0, 1, 0);
    const m1 = new THREE.Matrix4();

    return function(config) {
      const side = rand() > 0 ? 1 : -1;

      const start = v1
        .set(
          side * this.el.object3D.scale.x,
          rand() * this.el.object3D.scale.y,
          rand() * this.el.object3D.scale.z
        )
        .add(this.el.object3D.position);

      const end = v2
        .set(
          -side * this.el.object3D.scale.x,
          rand() * this.el.object3D.scale.y,
          rand() * this.el.object3D.scale.z
        )
        .add(this.el.object3D.position);

      const distance = v1.distanceTo(v2);
      const rotation = m1.lookAt(start, end, up);
      const bomberConfig = Object.assign(
        {
          distance,
          timeWarpFactor
        },
        config
      );
      const bomberPool = this.poolEl.components.mipool__bomber;
      const bomberEl = bomberPool.requestEntity();
      if (!bomberEl) {
        console.warn("No more bombers in the pool.");
        return undefined;
      }
      bomberEl.setAttribute("position", start);
      bomberEl.setAttribute("rotation", stringifyRotation(rotation));
      bomberEl.setAttribute("bomber", bomberConfig);
      bomberEl.components.bomber.reset();
      bomberEl.play();

      return bomberEl;
    };
  })(),
  inspectorenabled: bindEvent({ target: "a-scene" }, function() {
    this._debugPlaneLeft.visible = true;
    this._debugPlaneRight.visible = true;
  }),
  inspectordisabled: bindEvent({ target: "a-scene" }, function() {
    this._debugPlaneLeft.visible = false;
    this._debugPlaneRight.visible = false;
  }),
  gamestatechanged: bindEvent({ target: "[game-state]" }, function(evt) {
    const newState = evt.detail;
    if (newState === "Playing") {
      timeWarpFactor = 1;
      this.el.setAttribute("paused", false);
    } else {
      this.el.setAttribute("paused", true);
    }
  }),
  startTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    timeWarpFactor = evt.detail.factor;
  }),
  endTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    timeWarpFactor = 1;
  })
});
